import { __assign, __rest } from "tslib";
import React from 'react';
import VeltPersistentCommentModeLabelPrivateWireframe from './VeltPersistentCommentModeLabelPrivateWireframe/VeltPersistentCommentModeLabelPrivateWireframe';
import VeltPersistentCommentModeLabelPublicWireframe from './VeltPersistentCommentModeLabelPublicWireframe/VeltPersistentCommentModeLabelPublicWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltPersistentCommentModeLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-label-wireframe", __assign({}, transformedProps), children));
};
VeltPersistentCommentModeLabelWireframe.Private = VeltPersistentCommentModeLabelPrivateWireframe;
VeltPersistentCommentModeLabelWireframe.Public = VeltPersistentCommentModeLabelPublicWireframe;
export default VeltPersistentCommentModeLabelWireframe;
